import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { initialState } from './2284ReportingProgramOrgAddressInitialState';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getReportingProgram2284OrgAddress = createAsyncThunk(
  'stop/getReportingProgram2284OrgAddress',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const reportingProgram2284OrgAddressSlice = createSlice({
  name: 'stop/reportingProgram2284OrgAddress',
  initialState,
  reducers: {
    resetReportingProgram2284OrgAddress: () => initialState,
  },
  extraReducers: {
    [getReportingProgram2284OrgAddress.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const { resetReportingProgram2284OrgAddress } =
  reportingProgram2284OrgAddressSlice.actions;
export default reportingProgram2284OrgAddressSlice.reducer;
